import { Theme as ThemeProvider } from 'dx-sdk/build/providers';
import LogRocket from 'logrocket';
import Typography from 'pubweb-smokey/dist/components/Typography/Typography';
import { saveUTMSessionParams } from 'pubweb-smokey/dist/utils/utils';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import ClaytonFavicon from '../src/images/favicons/cla/favicon.png';
import CrosslandFavicon from '../src/images/favicons/csl/favicon.png';
import FreedomFavicon from '../src/images/favicons/fre/favicon.png';
import InternationalFavicon from '../src/images/favicons/int/favicon.png';
import LuvFavicon from '../src/images/favicons/luv/favicon.png';
import OakwoodFavicon from '../src/images/favicons/oak/favicon.png';
import TruFavicon from '../src/images/favicons/tru/favicon.png';
import Loading from '../src/images/svg/icons/Loading';
import GlobalStyle from './base.js';
import Banner from './components/Shared/Banner/Banner';
import Footer from './components/Shared/Footer/Footer';
import Header from './components/Shared/Header/Header';
import PortalLayout from './portal/components/PortalLayout/PortalLayout';
import { getLocalStorage, getSessionStorage, setSessionStorage } from './utils';

const App = ({
  children,
  dealer,
  homes,
  isLoading,
  hideFooter,
  hideHeader,
  hostname,
  match,
  home,
}) => {
  const getFavicon = () => {
    if (dealer && dealer.brandAcronym === 'FRE') {
      return FreedomFavicon;
    } else if (dealer && dealer.brandAcronym === 'OAK') {
      return OakwoodFavicon;
    } else if (dealer && dealer.brandAcronym === 'CSL') {
      return CrosslandFavicon;
    } else if (dealer && dealer.brandAcronym === 'LUV') {
      return LuvFavicon;
    } else if (dealer && dealer.brandAcronym === 'INT') {
      return InternationalFavicon;
    } else if (dealer && dealer.brandAcronym === 'TRU') {
      return TruFavicon;
    } else {
      return ClaytonFavicon;
    }
  };

  const loc = useLocation();
  const [isPortal, setIsPortal] = useState(false);

  console.log('emailPopupRemovalTest');

  const pageRouterLocation = useLocation().search;

  useEffect(() => {
    saveUTMSessionParams(pageRouterLocation);
  }, []);

  useEffect(() => {
    if (loc.pathname.startsWith('/portal')) {
      setIsPortal(true);
    } else {
      setIsPortal(false);
    }
  }, [loc]);

  LogRocket.init('uaifoo/retail-sites', {
    shouldDebugLog: false,
    release: 'mesa-verde',
  });

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Modular, Manufactured, Mobile Homes For Sale</title>
        <meta
          name="description"
          content="Building affordable, quality homes since 1956 as one of America's leading home builders. Come discover our selection of mobile, modular and manufactured homes today!"
        />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=5"
        />
        {dealer && <link rel="icon" type="image/png" href={getFavicon()} />}

        {/* Start VWO Async Smartcode */}
        <script type="text/javascript">
          {`window._vwo_code || (function() {
            var account_id=70507,
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();`}
        </script>
        {/* End VWO Async Smartcode */}

        {/* Start MNTN Tracking Pixel */}
        <script type="text/javascript">
          {`  (function () {
        'use strict';
        var e = null,
          b = '4.0.0',
          n = '34838',
          additional = 'term=value',
          t,
          r,
          i;
        try {
          t =
            top.document.referer !== ''
              ? encodeURIComponent(top.document.referrer.substring(0, 2048))
              : '';
        } catch (o) {
          t =
            document.referrer !== null
              ? document.referrer.toString().substring(0, 2048)
              : '';
        }
        try {
          r =
            window &&
            window.top &&
            document.location &&
            window.top.location === document.location
              ? document.location
              : window &&
                window.top &&
                window.top.location &&
                '' !== window.top.location
              ? window.top.location
              : document.location;
        } catch (u) {
          r = document.location;
        }
        try {
          i =
            parent.location.href !== ''
              ? encodeURIComponent(
                  parent.location.href.toString().substring(0, 2048)
                )
              : '';
        } catch (a) {
          try {
            i =
              r !== null
                ? encodeURIComponent(r.toString().substring(0, 2048))
                : '';
          } catch (f) {
            i = '';
          }
        }
        var l,
          c = document.createElement('script'),
          h = null,
          p = document.getElementsByTagName('script'),
          d = Number(p.length) - 1,
          v = document.getElementsByTagName('script')[d];
        if (typeof l === 'undefined') {
          l = Math.floor(Math.random() * 1e17);
        }
        h =
          'dx.mountain.com/spx?' +
          'dxver=' +
          b +
          '&shaid=' +
          n +
          '&tdr=' +
          t +
          '&plh=' +
          i +
          '&cb=' +
          l +
          additional;
        c.type = 'text/javascript';
        c.src =
          ('https:' === document.location.protocol ? 'https://' : 'http://') +
          h;
        v.parentNode.insertBefore(c, v);
      })();`}
        </script>
        {/* End MNTN Tracking Pixel*/}
        {/*Start Osano Privacy Script */}
        <script
          src={`https://cmp.osano.com/AzZd2RTbLigwQ5KJW/fc5c932e-d137-4fcf-ba8f-d9531da1e2ef/osano.js`}
          async
        />
        <style type="text/css">
          {`
      .osano-cm-widget {
        display: none;
      }
      .osano-cm-dialog {
        display: none;
       }
       `}
        </style>
        {/*End Osano Privacy Script*/}
      </Helmet>

      <Typography className="">
        <GlobalStyle />
        {isLoading && (
          <div className="loading-block">
            <Loading width="90px" color="#0075c9" />
          </div>
        )}

        {!isLoading && (
          <div className="page-wrapper">
            {/* {loc.pathname === '/' && (
              <Banner dealer={dealer} homes={homes}></Banner>
            )} */}
            {!hideHeader ? <Header dealer={dealer} homes={homes} /> : null}

            {isPortal && (
              <PortalLayout dealer={dealer} homes={homes} children={children} />
            )}
            {!isPortal && (
              <ThemeProvider theme={{}}>
                <main id="maincontent">{children}</main>
              </ThemeProvider>
            )}
            {!hideFooter && <Footer dealer={dealer} homes={homes} />}
          </div>
        )}
      </Typography>
    </>
  );
};

export default App;
